// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host .custom-snackbar-container .message {
  word-break: break-word;
  color: white !important;
}
:host .custom-snackbar-container button {
  width: 40px;
  min-width: unset;
}
:host .custom-snackbar-container button .mat-icon {
  margin: 0;
  color: white;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/custom-snackbar/custom-snackbar.component.scss"],"names":[],"mappings":"AAEE;EACC,sBAAA;EACA,uBAAA;AADH;AAIE;EACC,WAAA;EACA,gBAAA;AAFH;AAIG;EACC,SAAA;EACA,YAAA;AAFJ","sourcesContent":[":host {\n\t.custom-snackbar-container {\n\t\t.message {\n\t\t\tword-break: break-word;\n\t\t\tcolor: white !important;\n\t\t}\n\n\t\tbutton {\n\t\t\twidth: 40px;\n\t\t\tmin-width: unset;\n\n\t\t\t.mat-icon {\n\t\t\t\tmargin: 0;\n\t\t\t\tcolor: white;\n\t\t\t}\n\t\t}\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
